//Colors
export const COLOR_WARNING_STATUS = '#F0CB2F';
export const COLOR_GRAY = '#424E54';
export const COLOR_GRAY_ICON = '#727E84';
export const COLOR_BLUE_ICON= '#007BC1';
export const COLOR_RED_ICON= '#CA3C3D'